/** @typedef {import("../../../api/types").StatsMix} StatsMix */
import React from "react";
import {Table} from "reactstrap";
import InfoTip from "../../../shared/components/InfoTip";
import {formatMoney, formatPercent} from "../../../shared/utils/format";
import "./MixCard.css";

const ROWS = /** @type {const} */ ([
    ["services", "Serviços"],
    ["products", "Produtos"],
]);

/**
 * What the services and what the products brought in this month: revenue,
 * cost, profit and margin of the paid orders, split by kind of line.
 *
 * @param {{data: StatsMix|null, error?: boolean}} props `data` is null while loading
 */
const MixCard = ({data, error = false}) => {
    let body;
    if (error) {
        body = <p className="mix__note">Não foi possível carregar esta parte.</p>;
    } else if (!data) {
        body = <p className="mix__note">Carregando…</p>;
    } else if (Number(data.total.revenue) === 0 && Number(data.total.cost) === 0) {
        body = <p className="mix__note">Nenhuma ordem paga neste mês ainda.</p>;
    } else {
        const {currency} = data;
        const margin = (figures) => (figures.margin === null ? "–" : formatPercent(Number(figures.margin)));
        body = (
            <Table size="sm" responsive className="mix__table mb-0">
                <thead>
                    <tr>
                        <th />
                        <th className="text-end">Receita</th>
                        <th className="text-end">Custo</th>
                        <th className="text-end">Lucro</th>
                        <th className="text-end">Margem</th>
                    </tr>
                </thead>
                <tbody>
                    {ROWS.map(([key, label]) => (
                        <tr key={key}>
                            <th scope="row">{label}</th>
                            <td className="text-end">{formatMoney(data[key].revenue, currency)}</td>
                            <td className="text-end">{formatMoney(data[key].cost, currency)}</td>
                            <td className="text-end">{formatMoney(data[key].profit, currency)}</td>
                            <td className="text-end">{margin(data[key])}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <th scope="row">Total</th>
                        <td className="text-end">{formatMoney(data.total.revenue, currency)}</td>
                        <td className="text-end">{formatMoney(data.total.cost, currency)}</td>
                        <td className="text-end">{formatMoney(data.total.profit, currency)}</td>
                        <td className="text-end">{margin(data.total)}</td>
                    </tr>
                </tfoot>
            </Table>
        );
    }

    return (
        <section className="mix" aria-labelledby="mix-title">
            <h5 id="mix-title" className="mb-3">
                Serviços e produtos neste mês
                <InfoTip>
                    Das ordens pagas neste mês. O desconto de cada ordem é dividido entre serviços e produtos na mesma
                    proporção do que cada um valia, então os dois somam a receita do mês.
                </InfoTip>
            </h5>
            {body}
        </section>
    );
};

export default MixCard;
